import { assets } from "./assets";

export type Category = "smartEnergy" | "productRnD" | "aiService";

export type ProductId =
  | "pvPlatform"
  | "energyBackend"
  | "chillerDashboard"
  | "pvController"
  | "switchgear"
  | "edgeGateway"
  | "llmService";

export type Product = {
  id: ProductId;
  category: Category;
  image: string;
  fit?: "cover" | "contain";
};

export const products: Product[] = [
  { id: "pvPlatform", category: "smartEnergy", image: assets.energyDashboard, fit: "contain" },
  { id: "energyBackend", category: "smartEnergy", image: assets.energyBackend, fit: "contain" },
  { id: "chillerDashboard", category: "smartEnergy", image: assets.chillerDashboard, fit: "contain" },
  { id: "pvController", category: "smartEnergy", image: assets.pvController },
  { id: "switchgear", category: "smartEnergy", image: assets.switchgear },
  { id: "edgeGateway", category: "productRnD", image: assets.industrialPc, fit: "contain" },
  { id: "llmService", category: "aiService", image: assets.llmService, fit: "contain" },
];
